export default "__VITE_ASSET__XAo09DEA__"